import type * as React from 'react';
import { del } from '@Domain/Api';
import type { UserPayload } from '@Application/Users/Users/Actions/usersFetched';
import userMfaReset, { type UserMfaResetAction } from '@Application/Users/Users/Actions/userMfaReset';
import userMfaResetFailed, {
	type UserMfaResetFailedAction,
} from '@Application/Users/Users/Actions/userMfaResetFailed';
import type ResetUserMfa from '@Application/Users/Users/Commands/ResetUserMfa';
import extractMessages from '@Infra/FetchLib/ApiError/extractMessages';
import parameters from '../../../parameters';

type Actions = UserMfaResetAction | UserMfaResetFailedAction;

export default (command: ResetUserMfa) => {
	return async (dispatch: React.Dispatch<Actions>): Promise<Actions> => {
		try {
			const payload = await del<UserPayload>(
				`${parameters.api.host}/api/accounts/${command.accountId}/users/${command.userId}/mfa-credential`,
			);

			const action = userMfaReset(payload, command.accountId);
			dispatch(action);
			return action;
		} catch (error) {
			const action = userMfaResetFailed(extractMessages(error));
			dispatch(action);
			return Promise.reject(action);
		}
	};
};
